import { Icon } from '@iconify/react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import ModalWrapper from './ModalWrapper';

export default function SuccessModal({ open, onClose, message, maxWidth = 'sm' }: { open: any; onClose: any; message: any; maxWidth?: any }) {
  useEffect(() => {
    if (!open) return;
    const timer = setTimeout(() => {
      onClose();
    }, 5000);
    return () => clearTimeout(timer);
  }, [onClose, open]);

  return (
    <ModalWrapper open={open} onClose={onClose} maxWidth={maxWidth || 'sm'}>
      <Stack
        direction='column'
        sx={{
          alignItems: 'center',
          gap: 2,
          borderRadius: '8px',
          padding: '24px',
          '& > svg': { color: 'primary.light' },
        }}
      >
        <Icon icon='icon-park-solid:success' width={24} />
        <Typography sx={{ fontSize: '1.125rem', color: 'grey.600', textAlign: 'center' }}>
          {message}
        </Typography>
      </Stack>
    </ModalWrapper>
  );
}
